import React from 'react';

import styles from './dev-hub-page-body.module.less';

export const DevHubPageBody = ({children}: {children?: React.ReactNode}) => {
    return <div className={styles.wrapper}>{children}</div>;
};
